import { language, DeliveryInterval } from "@chef/constants";

export const intervals = {
  no: {
    10: "hver uke",
    20: "partallsuker",
    30: "oddetallsuker",
  },
  se: {
    10: "varje vecka",
    20: "varannan vecka",
    30: "varannan vecka",
  },
  dk: {
    10: "hver uge",
    20: "lige ugenumre",
    30: "ulige ugenumre",
  },
}[language];

export const intl = (
  {
    no: {
      FIRST_DELIVERY_MESSAGE: "Vennligst merk at din første leveranse kommer:",
      YOUR_MEALBOX_GETS_DELIVERED: (interval: DeliveryInterval) =>
        `Din matkasse blir levert ${intervals[interval]}.`,
      CHANGE_DELIVERY_INTERVAL_INFO:
        'Du kan endre leveringsintervall via "Min konto" eller pause enkelte leveranser via "Min meny". Endringer kan gjøres senest mandag kl. 23.59, en uke før planlagt leveranse.',
      CONFIRM_TEXT: "Jeg forstår",
    },

    se: {
      FIRST_DELIVERY_MESSAGE: "Vänligen notera att din första leverans kommer:",
      YOUR_MEALBOX_GETS_DELIVERED: (interval: DeliveryInterval) =>
        `Din matkasse levereras ${intervals[interval]}.`,
      CHANGE_DELIVERY_INTERVAL_INFO:
        'Du kan ändra leveransintervall via "Mitt konto" eller pausa enskilda leveranser via "Min meny". Ändringar kan göras senast måndag kl. 23.59 en vecka innan planerad leverans.',
      CONFIRM_TEXT: "Jag förstår",
    },

    dk: {
      FIRST_DELIVERY_MESSAGE:
        "Bemærk venligst, at din første levering vil være:",
      YOUR_MEALBOX_GETS_DELIVERED: (interval: DeliveryInterval) =>
        `Din måltidskasse bliver leveret ${intervals[interval]}.`,
      CHANGE_DELIVERY_INTERVAL_INFO:
        'Du kan ændre leveringsintervaller via "Min konto" eller pause individuelle leveringer via "Min menu". Ændringer kan ske senest onsdag kl 23.59 en uge før planlagt levering.',
      CONFIRM_TEXT: "Forstået!",
    },
  } as const
)[language];
